import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, TextField, Card, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import {CheckTwoTone, Settings, TimelineTwoTone, PrintTwoTone, UndoTwoTone, VisibilityRounded} from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import Toggle from './Toggle';
import ReactToPrint from 'react-to-print';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import ViewAssessment from './ViewAssessment';
import ViewThreeSixtyReport from './View360LeadershipReport';
import ViewTMReport from './ViewTMReport';

export default class EmployeeAssessmentsReport extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            querying: true,
            search_name: '',
            search_number: '',
            search_branch: '',
            search_rom: '',
            search_ready: false,
            searching: false,
            employees_array: [],
            show_employees: false,
            include_archived_cycles: false,
            include_archived_interventions: false,
            include_unapproved_assessments: false,
            include_unapproved_interventions: false,
            selected_employee: {},
            generating_report: false,
            report_data_received: false,
            got_assessments: false,
            got_interventions: false,
            got_360_data: false,
            got_tm_data: false,
            got_comp_data: false,
            got_qual_data: false,
            got_lms_data: false,
            assessments_array: [],
            interventions_array: [],
            three_sixty_array: [],
            tm_array: [],
            comps_array: [],
            quals_array: [],
            lms_array: [],
            assessment: {},
            show_assessment: false,
        }

        this.state = {
            error: false,
            error_message: '',
            querying: true,
            search_name: '',
            search_number: '',
            search_branch: '',
            search_rom: '',
            search_ready: false,
            searching: false,
            employees_array: [],
            show_employees: false,
            include_archived_cycles: false,
            include_archived_interventions: false,
            include_unapproved_assessments: false,
            include_unapproved_interventions: false,
            selected_employee: {},
            generating_report: false,
            report_data_received: false,
            got_assessments: false,
            got_interventions: false,
            got_360_data: false,
            got_tm_data: false,
            got_comp_data: false,
            got_qual_data: false,
            got_lms_data: false,
            assessments_array: [],
            interventions_array: [],
            three_sixty_array: [],
            tm_array: [],
            comps_array: [],
            quals_array: [],
            lms_array: [],
            assessment: {},
            show_assessment: false,
        };

        this.datasheetFieldSpecs = [
            { field: 'nominate', headerName: 'Report', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton
                    onClick={()=>this.fetchProfileData(parms)}
                    color='primary' 
                >
                    <TimelineTwoTone/>
                </IconButton>
            )},
            { field: 'store_code', headerName: 'Branch', width: 110, align:'center',headerAlign:'center'},
            { field: 'id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'store', headerName: 'Store', width: 160},
            { field: 'region', headerName: 'Region', width: 150},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125}
        ]

        this.datasheetFieldSpecs_assessments = [
            // { field: 'assessee', headerName: 'Assessee', width: 160},
            { field: 'view', headerName: 'View', width: 70, headerAlign: 'center', align:'center',sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.viewAssessment(parms)} 
                >
                    <VisibilityRounded/>
                </IconButton>
            )},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 140},
            { field: 'assessment_template_id', headerName: 'Type', width: 90, align:'center',headerAlign:'center'},
            { field: 'assessment_type_id', headerName: 'By', align: 'center', headerAlign:'center', width: 80, sortable:false},
            { field: 'created', headerName: 'Created', headerAlign:'center', align:'center', width: 120},
            { field: 'key_datapoint_score', headerName: 'Score', headerAlign:'right',align:'right', width: 100, sortable:false},
            { field: 'key_datapoint_score_override', headerName: 'Override?', headerAlign:'right',align:'right', width: 100, sortable:false},
            { field: 'key_datapoint_out_of', headerName: 'Out Of', width: 100, headerAlign:'right',align:'right', sortable:false},
            { field: 'approved', headerName: 'Approved?', align: 'center',width: 100, sortable: false},
            { field: 'archived', headerName: 'Archived?', align: 'center',width: 100, sortable: false},
            { field: 'key_comment', headerName: 'Comment', width: 500, sortable:false},
        ]

        this.datasheetFieldSpecs_360 = [
            // { field: 'name', headerName: 'Assessee', width: 160},
            { field: 'view', headerName: 'View', width: 70, headerAlign: 'center', align:'center',sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.viewAssessment(parms)} 
                >
                    <VisibilityRounded/>
                </IconButton>
            )},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 140},
            { field: 'original_average_score', headerName: 'Original Score', headerAlign:'right',align:'right', width: 140, sortable:false},
            { field: 'final_average_score', headerName: 'Final Score', headerAlign:'right',align:'right', width: 140, sortable:false},
            { field: 'assessment_count', headerName: 'Assessments', width: 120, sortable:false, align: 'center'},
            { field: 'spacer', headerName: ' ', width: 500, sortable:false, align: 'center'},
        ]

        this.datasheetFieldSpecs_tm = [
            // { field: 'name', headerName: 'Assessee', width: 160},
            { field: 'view', headerName: 'View', width: 70, headerAlign: 'center', align:'center',sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.viewAssessment(parms)} 
                >
                    <VisibilityRounded/>
                </IconButton>
            )},
            { field: 'cycle_code', headerName: 'Cycle Code', width: 140},
            { field: 'KPI_original_score', headerName: 'KPI Original Score', headerAlign:'right',align:'right', width: 150, sortable:false},
            { field: 'KPI_final_score', headerName: 'KPI Final Score', headerAlign:'right',align:'right', width: 140, sortable:false},
            { field: 'PM_original_score', headerName: 'PM Original Score', headerAlign:'right',align:'right', width: 155, sortable:false},
            { field: 'PM_final_score', headerName: 'PM Final Score', headerAlign:'right',align:'right', width: 140, sortable:false},
            { field: 'original_classification', headerName: 'Original Classification', width: 175, sortable:false, align: 'center'},
            { field: 'final_classification', headerName: 'Final Classification', width: 175, sortable:false, align: 'center'},
        ]

        this.datasheetFieldSpecs_interventions = [
            // { field: 'employee', headerName: 'Employee', width: 160},
            { field: 'intervention', headerName: 'Intervention', width: 300},
            // { field: 'employee', headerName: 'Completed By', width: 160},
            { field: 'assignor', headerName: 'Assigned By', width: 160},
            { field: 'created', headerName: 'Assigned', width: 120},
            { field: 'completed_date', headerName: 'Completed', width: 130},
            { field: 'approved', headerName: 'Approved?', align: 'center',width: 100, sortable: false},
            { field: 'archived', headerName: 'Archived?', align: 'center',width: 100, sortable: false},
            { field: 'spacer', headerName: ' ', width: 120, sortable:false, align: 'center'},
        ]

        this.datasheetFieldSpecs_competencies = [
            // { field: 'employee', headerName: 'Employee', width: 160},
            { field: 'division', headerName: 'Division', width: 150, sortable:false},
            { field: 'aspect', headerName: 'Function', width: 150},
            { field: 'competency', headerName: 'Competency', width: 500, sortable:false},
            { field: 'competency_rating', headerName: 'Rating', width: 130},
            { field: 'created', headerName: 'Rated On', width: 110, sortable:false},
            { field: 'cycle_code', headerName: 'Ass. Cycle', width: 120, sortable:false},
            { field: 'approved', headerName: 'Approved?', align: 'center',width: 100, sortable: false},
            // { field: 'spacer', headerName: ' ', width: 120, sortable:false, align: 'center'},
        ]

        this.datasheetFieldSpecs_qualifications = [
            { field: 'qualification_type', headerName: 'Qual. Type', width: 250, sortable:false},
            { field: 'qual_discipline', headerName: 'Academic Discipline', width: 210, sortable:false},
            { field: 'description', headerName: 'Description', width: 200, sortable: false},
            { field: 'nqf_level', headerName: 'NQF level', width: 75, align:'center', sortable:false},
            { field: 'year_obtained', headerName: 'Year Obtained', width: 100, align:'center'},
            { field: 'file_attachment', headerName: 'Document Attached', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.file_attachment==="YES")&&
                <IconButton
                    onClick={()=>this.viewDoc(parms)} 
                >
                   <VisibilityRounded/>
                </IconButton>
            )},
            { field: 'comment', headerName: 'Comment', width: 300, sortable:false}
        ]

        this.datasheetFieldSpecs_certificates = [
            // { field: 'employee', headerName: 'Employee', width: 160},
            { field: 'name', headerName: 'Certificate / Badge', width: 350, sortable:false},
            { field: 'description', headerName: 'Achievement', width: 300, sortable:false},
            { field: 'issued', headerName: 'Issued', width: 120},
            { field: 'issuername', headerName: 'Issued By', width: 130},
            { field: 'spacer', headerName: ' ', width: 120, sortable:false, align: 'center'},
        ]

    }

    componentDidMount = () => {
    };

    viewAssessment = (record) => {
        // console.log('record.row :>> ', record.row);
        if (record.row.final_average_score){
            //this is a 360 report...
            this.setState({current_record:record.row,show_view: true,view_type:'360'});
        } else if (record.row.final_classification){
            //this is a TM report...
            this.setState({current_record:record.row,show_view: true,view_type:'TM'});
        } else {
            // this is a normal assessment...
            this.setState({current_record:record.row,show_view: true,view_type:'assessment'});
        }
    }
    
    runSearch = (e) => {
        e.preventDefault();
        // console.log('e :>> ', e);

        if (!this.state.search_name&&!this.state.search_number&&!this.state.search_branch&&!this.state.search_rom){return}

        this.setState({searching:true, search_ready:false,employees_array:[]});

        var params = {search_string: this.state.search_name, search_type:'surname'};
        if (this.state.search_number){params={search_string: this.state.search_number, search_type:'employee number'}}
        if (this.state.search_branch){params={search_string: this.state.search_branch, search_type:'branch'}}
        if (this.state.search_rom){params={search_string: this.state.search_rom, search_type:'rom'}}

        Gserv.sendCommand('find_users_for_profile_report',this.props.gwt,params)
        .then(reply => {
            // console.log('search reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (find_users_for_profile_report) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (find_users_for_profile_report) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                //not broken, but for some reason couldn't update / add record
                if (reply.statusCode===204){
                    this.setState({error:true,error_message:"No employee records found matching the search.",searching:false});
                } else {
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."})
                }
            } else {
                if (reply.Records){
                    let record_array = reply.Records;
                    let DOE = null;
                    for (var i=0;i<record_array.length;i++){
                        DOE = new moment(record_array[i].date_of_entry).format("YYYY-MM-DD");
                        record_array[i].date_of_entry = DOE;
                    }
                }
                this.setState({employees_array:reply.Records,show_employees:true,searching:false,search_ready:true});
            }
        });
    }

    resetMe = () => {
        this.setState(this.initial_state);        
    }

    returnToSearch = () => {
        this.setState({
            report_data_received: false,
            got_assessments: false,
            got_interventions: false,
            got_360_data: false,
            got_tm_data: false,
            include_archived_cycles: false,
            include_archived_interventions: false,
            include_unapproved_assessments: false,
            include_unapproved_interventions: false,
        })
    }

    handleToggleChange = (e) => {
        // console.log('e :>> ', e);
        switch (e.field) {
            case 'include_archived_cycles':
                this.setState({include_archived_cycles:e.value});
                break;

            case 'include_archived_interventions':
                this.setState({include_archived_interventions:e.value});
                break;

            case 'include_unapproved_assessments':
                this.setState({include_unapproved_assessments:e.value});
                break;

            case 'include_unapproved_interventions':
                this.setState({include_unapproved_interventions:e.value});
                break;
        
            default:
                break;
        }
    }

    fetchProfileData = (record) => {
        // console.log('called build for record :>> ', record);
        this.setState({generating_report:true,selected_employee:record.row});

        //async fetch assesment data...
        Gserv.sendCommand('query_assessments_for_profile',this.props.gwt,{
            employee_number: record.id,
            include_archived_cycles: this.state.include_archived_cycles,
            include_unapproved_assessments: this.state.include_unapproved_assessments
        })
        .then(reply=>{
            // console.log('query_assessments_for_profile :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_assessments_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_assessments_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {               
                //clean formats for display
                if (reply.Records){
                    let record_array = reply.Records;
                    // let deadline_date = null;
                    let created = null;
                    for (var i=0;i<record_array.length;i++){
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        // if (record_array[i].deadline_date){
                        //     deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                        //     record_array[i].deadline_date = deadline_date;
                        // }
                        record_array[i].approved = record_array[i].approved? "YES" : "";
                        record_array[i].archived = record_array[i].archived? "YES" : "";
                    }

                }
                this.setState({got_assessments:true, assessments_array:reply.Records?reply.Records : []});
                if (this.state.got_interventions&&this.state.got_360_data&&this.state.got_tm_data&&this.state.got_comp_data&&this.state.got_lms_data&&this.state.got_qual_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        });

        //Async fetch intervention data...
        Gserv.sendCommand('query_interventions_for_profile',this.props.gwt,{
            employee_number: record.id,
            include_archived_interventions: this.state.include_archived_interventions,
            include_unapproved_interventions: this.state.include_unapproved_interventions
        })
        .then(reply=>{
            // console.log('query_interventions_for_profile reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_interventions_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_interventions_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    let created = null;
                    let completed = null;
                    for (var i=0;i<record_array.length;i++){
                        if (record_array[i].deadline_date){
                            deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                            record_array[i].deadline_date = deadline_date;
                        }
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        if (record_array[i].completed_date){
                            completed = new moment(record_array[i].completed_date).format("YYYY-MM-DD");
                            record_array[i].completed_date = completed;
                        }
                        record_array[i].approved = record_array[i].approved? "YES" : null;
                        record_array[i].archived = record_array[i].archived? "YES" : null;

                    }
                }
                this.setState({got_interventions:true, interventions_array:reply.Records?reply.Records : []});
                if (this.state.got_interventions&&this.state.got_360_data&&this.state.got_tm_data&&this.state.got_comp_data&&this.state.got_lms_data&&this.state.got_qual_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        });

        //Async fetch 360 data...
        Gserv.sendCommand('query_360_avail_for_profile',this.props.gwt,{
            employee_number: record.id,
        })
        .then(reports_avail => {
            // console.log('360_reports_avail :>> ', reports_avail);
            if (reports_avail.error){
                console.log('error on return from Gserv (query_360_avail_for_profile) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reports_avail.Result!=="Success"&&reports_avail.statusCode!==204){
                console.log('error on return from Gserv (query_360_avail_for_profile) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({got_360_data:true, three_sixty_array:reports_avail.Records?reports_avail.Records : []});
                if (this.state.got_interventions&&this.state.got_360_data&&this.state.got_tm_data&&this.state.got_comp_data&&this.state.got_lms_data&&this.state.got_qual_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        }); 

        //Async fetch TM data...
        Gserv.sendCommand('query_tm_avail_for_profile',this.props.gwt,{
            employee_number: record.id,
        })
        .then(reports_avail => {
            // console.log('tm_reports_avail :>> ', reports_avail);
            if (reports_avail.error){
                console.log('error on return from Gserv (query_tm_avail_for_profile) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reports_avail.Result!=="Success"&&reports_avail.statusCode!==204){
                console.log('error on return from Gserv (query_tm_avail_for_profile) :>> ', reports_avail);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({got_tm_data:true, tm_array:reports_avail.Records?reports_avail.Records : []});
                if (this.state.got_interventions&&this.state.got_360_data&&this.state.got_tm_data&&this.state.got_comp_data&&this.state.got_lms_data&&this.state.got_qual_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        }); 

        // async fetch competency data...
        Gserv.sendCommand('query_ca_assessments_for_profile',this.props.gwt,{
        employee_number: record.id,
            include_archived_cycles: this.state.include_archived_cycles,
            include_unapproved_assessments: this.state.include_unapproved_assessments
        })
        .then(reply=>{
            // console.log('query_ca_assessments_for_profile :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_ca_assessments_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_ca_assessments_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {               
                //clean formats for display
                if (reply.Records){
                    let record_array = reply.Records;
                    // let deadline_date = null;
                    let created = null;
                    for (var i=0;i<record_array.length;i++){
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        // if (record_array[i].deadline_date){
                        //     deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                        //     record_array[i].deadline_date = deadline_date;
                        // }
                        record_array[i].approved = record_array[i].approved? "YES" : "";
                        record_array[i].archived = record_array[i].archived? "YES" : "";
                        // record_array[i].archived = record_array[i].archived? "YES" : "";
                    }
                }
                this.setState({got_comp_data:true, comps_array:reply.Records?reply.Records : []});
                if (this.state.got_interventions&&this.state.got_360_data&&this.state.got_tm_data&&this.state.got_comp_data&&this.state.got_lms_data&&this.state.got_qual_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        });

        // async fetch LMS data...
        Gserv.sendCommand('query_lms_badges_for_profile',this.props.gwt,{
            employee_number: record.id,
            employee_id_num: record.row.id_number
        })
        .then(reply=>{
            // console.log('query_lms_badges_for_profile :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_lms_badges_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_lms_badges_for_profile) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {               
                //clean formats for display
                if (reply.Records){
                    // let record_array = reply.Records;
                    // let deadline_date = null;
                    // let issued = null;
                    // for (var i=0;i<record_array.length;i++){
                        // issued = new moment(record_array[i].issued).format("YYYY-MM-DD");
                        // record_array[i].created = created;
                        // if (record_array[i].deadline_date){
                        //     deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                        //     record_array[i].deadline_date = deadline_date;
                        // }
                        // record_array[i].approved = record_array[i].approved? "YES" : "";
                        // record_array[i].archived = record_array[i].archived? "YES" : "";
                        // record_array[i].archived = record_array[i].archived? "YES" : "";
                    // }
                }
                this.setState({got_lms_data:true, lms_array:reply.Records?reply.Records : []});
                if (this.state.got_interventions&&this.state.got_360_data&&this.state.got_tm_data&&this.state.got_comp_data&&this.state.got_lms_data&&this.state.got_qual_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        });

        // async fetch Qual data...
        Gserv.sendCommand('query_employee_qualifications',this.props.gwt,{
            employee_number: record.id,
            employee_id_num: record.row.id_number
        })
        .then(reply=>{
            // console.log('query_employee_qualifications :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_employee_qualifications) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_employee_qualifications) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {               
                //clean formats for display
                let record_array = reply.Records;
                if (reply.Records){
                    for (var i=0;i<record_array.length;i++){
                        record_array[i].nqf_level = record_array[i].nqf_level? record_array[i].nqf_level : "N/A";
                    }
                }
                this.setState({got_qual_data:true, quals_array:reply.Records? record_array : []});
                if (this.state.got_interventions&&this.state.got_360_data&&this.state.got_tm_data&&this.state.got_comp_data&&this.state.got_lms_data&&this.state.got_qual_data){
                    this.setState({report_data_received:true,generating_report:false});
                }
            }
        });
        

    }

    viewDoc = (parms) => {
        // console.log('parms.row :>> ', parms.row);
        this.setState({querying:true});
        Gserv.sendCommand('query_qualification_attachment',this.props.gwt,{
            file_key: parms.row.file_key
        })
        .then(file_url => {
            // console.log('file_url obj returned :>> ', file_url);
            if (file_url.error){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (file_url.Result!=="Success"&&file_url.statusCode!==204){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                window.open(file_url.Url, '_blank', 'noopener,noreferrer');
                // const newWindow = window.open(file_url.Url, '_blank', 'noopener,noreferrer');
                // if (newWindow) newWindow.opener = null
            }
            this.setState({querying:false})
        }); 
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var wb = XLSX.utils.book_new();
            var ws = XLSX.utils.json_to_sheet(this.state.assessments_array);
            XLSX.utils.book_append_sheet(wb, ws, 'Assessment History ' + dateStr);
            if (this.state.three_sixty_array.length>0){
                ws = XLSX.utils.json_to_sheet(this.state.three_sixty_array);
                XLSX.utils.book_append_sheet(wb, ws, '360 Reports ' + dateStr);
            }
            if (this.state.tm_array.length>0){
                ws = XLSX.utils.json_to_sheet(this.state.tm_array);
                XLSX.utils.book_append_sheet(wb, ws, 'TM Reports ' + dateStr);
            }
            if (this.state.interventions_array.length>0){
                ws = XLSX.utils.json_to_sheet(this.state.interventions_array);
                XLSX.utils.book_append_sheet(wb, ws, 'Interventions ' + dateStr);
            }

            //Write to browser
            XLSX.writeFile(wb,'TMS Export - Employee Profile Data for ' + this.state.selected_employee.name + ' #' + this.state.selected_employee.id + ' [' + this.state.selected_employee.store_code  + '] - as at ' + dateStr + '.xlsx');
        }
    }

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >

            <Grid item>

                {!this.state.generating_report&&!this.state.report_data_received&&!this.state.show_view&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1250
                    }}
                >

                    <Typography color='primary' style={{paddingTop:'15px'}}>
                        Employee Assessments & Qualifications
                    </Typography>

                    {this.props.admin&&
                    <Card
                        elevation={2}
                        style={{marginTop:'15px'}}
                    >

                        <Grid 
                            container 
                            direction='row'
                            justifyContent='center'
                            alignItems='center'
                            style={{padding:'10px', paddingLeft:'50px'}}
                        >

                            <Grid item xs={6}>
                            <Toggle 
                                fieldMap={{field: "include_unapproved_assessments", headerName: "Show Assessments pending review?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                setField={this.handleToggleChange}
                            />
                            </Grid>

                            <Grid item xs={6}>
                            <Toggle 
                                fieldMap={{field: "include_unapproved_interventions", headerName: "Show Learning Interventions pending review?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                setField={this.handleToggleChange}
                            />
                            </Grid>

                            <Grid item xs={6}>
                            <Toggle 
                                fieldMap={{field: "include_archived_cycles", headerName: "Show archived Assessments?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                setField={this.handleToggleChange}
                            />
                            </Grid>

                            <Grid item xs={6}>
                            <Toggle 
                                fieldMap={{field: "include_archived_interventions", headerName: "Show archived Learning Interventions?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                                setField={this.handleToggleChange}
                            />
                            </Grid>

                        </Grid>
                    </Card>}

                    <form onSubmit={this.runSearch}>

                        <TextField
                            id='surname'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={true}
                            label={'Surname Search'}
                            variant='outlined'
                            value={this.state.search_name}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_name: outText, search_number: '',search_branch:'', search_rom:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px'}}
                            disabled={this.state.searching||this.state.error}
                        />

                        <TextField
                            id='emplNum'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Employee # Search'}
                            variant='outlined'
                            value={this.state.search_number}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^ A-Za-z0-9]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_number: outText, search_name:"", search_branch:"", search_rom:"", search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px', marginTop: '15px', marginLeft:'10px'}}
                            disabled={this.state.searching}
                        />
                        
                        <TextField
                            id='branchCode'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Branch Code Search'}
                            variant='outlined'
                            value={this.state.search_branch}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>2);
                                this.setState({search_branch:outText, search_name: '', search_number: '', search_rom:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px', marginLeft:'10px'}}
                            disabled={this.state.searching||this.state.error}
                        />

                        {this.props.admin&&
                        <TextField
                            id='romCode'
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            autoFocus={false}
                            label={'Manager Code Search'}
                            variant='outlined'
                            value={this.state.search_rom}
                            onChange={(e) => {
                                const outText = e.target.value.replace(/[^A-Za-z]+/g, '').toUpperCase();
                                const can_sub = (outText.length>1);
                                this.setState({search_rom:outText, search_name: '', search_number: '', search_branch:'', search_ready: can_sub, error: false});
                            }}
                            // required
                            style={{marginBottom:'10px',marginTop:'15px', marginLeft:'10px'}}
                            disabled={this.state.searching||this.state.error}
                        />}

                        <br/>

                        <Button
                            variant='contained'
                            color='primary'
                            type='submit'
                            style={{marginLeft:'10px',marginBottom:'15px'}}
                            disabled={!this.state.search_ready}
                        >
                            Search
                        </Button>

                    </form>

                    {this.state.show_employees&&
                    <DatasheetView 
                        dataset={this.state.employees_array}
                        fieldspecs={this.datasheetFieldSpecs}
                        delete={false}
                        edit={false}
                        handleDelete={null}
                        handleEdit={null}
                        loading={this.state.searching}
                        deleteHeaderName={'Delete'}
                        // height={350}
                    />}

                </Paper>}

                {this.state.generating_report&&!this.state.error&&!this.state.show_view&&
                <div>

                    <Settings className='icn-spinner' /> Querying assessment & qualification data for {this.state.selected_employee.name} ({this.state.selected_employee.job_title})...

                    {this.state.got_assessments&&
                    <Typography><CheckTwoTone color='primary'/> Assesment history retrieved... </Typography>}

                    {this.state.got_interventions&&
                    <Typography><CheckTwoTone color='primary'/> Intervention history retrieved... </Typography>}

                    {this.state.got_360_data&&
                    <Typography><CheckTwoTone color='primary'/> 360 Leadership Reports retrieved... </Typography>}

                    {this.state.got_tm_data&&
                    <Typography><CheckTwoTone color='primary'/> Talent Matrix Reports retrieved... </Typography>}
                    
                    {this.state.got_qual_data&&
                    <Typography><CheckTwoTone color='primary'/> Qualification data retrieved... </Typography>}
                    
                    {this.state.got_comp_data&&
                    <Typography><CheckTwoTone color='primary'/> Competency data retrieved... </Typography>}

                    {this.state.got_lms_data&&
                    <Typography><CheckTwoTone color='primary'/> AutoExcel Certificates retrieved... </Typography>}
                
                </div>}

                {this.state.report_data_received&&!this.state.error&&!this.state.show_view&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            width:'100%',
                            paddingTop: 15,
                            paddingBottom: 15,
                            marginBottom: 2
                        }}
                    >
                        <Tooltip title="Back"><IconButton aria-label='Back' onClick={this.returnToSearch}><UndoTwoTone /></IconButton></Tooltip>

                        <Tooltip title="Print or save as .pdf">
                            <span>
                            <ReactToPrint
                                content={() => this.componentRef}
                                bodyClass={'printSpecs'}
                                trigger={() => <IconButton aria-label='Print or save as .pdf'><PrintTwoTone /></IconButton>}
                            />
                            </span>
                        </Tooltip>

                        <Tooltip title="Export to Excel">
                        <span>
                        <IconButton 
                            aria-label='Export to Excel'
                            onClick={this.exportMe}
                            disabled={this.state.assessments_array.length===0}
                        >
                            <ExcelLogo />
                        </IconButton>
                        </span>
                        </Tooltip>

                    </Paper>

                    <div id='Print Delimiter' 
                        ref={(response) => (this.componentRef = response)}
                    >        
                        <style type="text/css" media="print">
                            {"@page { size: landscape; }"}
                        </style>

                        <Card
                            elevation={2}
                            style={{padding:'10px'}}
                        >
                            <Typography color='primary' style={{paddingTop:'10px'}}>
                                Employee Profile Report
                            </Typography>

                            <Typography><b>{this.state.selected_employee.name}</b> ({this.state.selected_employee.job_title}) {this.state.selected_employee.store}, {this.state.selected_employee.region}</Typography>    
                            <Typography>Date of Entry: {this.state.selected_employee.date_of_entry}  &nbsp;&nbsp;&nbsp;Reports to Manager: {this.state.selected_employee.reports_to_rom} &nbsp;&nbsp;&nbsp;Report Generated: {new Date().toDateString()} </Typography>
                        </Card>

                        {/* Assessments datagrid */}
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Assessment History</Typography>
                        <DatasheetView 
                            dataset={this.state.assessments_array}
                            fieldspecs={this.datasheetFieldSpecs_assessments}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.querying}
                            deleteHeaderName={''}
                            // pagesize={10}
                            // height={500}
                        />


                        {/* 360 datagrid */}
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>360 Leadership Assessment Reports on File</Typography>
                        <DatasheetView 
                            dataset={this.state.three_sixty_array}
                            fieldspecs={this.datasheetFieldSpecs_360}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.querying}
                            deleteHeaderName={''}
                            // pagesize={10}
                            // height={500}
                        />


                        {/* TM datagrid */}
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Talent Matrix Reports on File</Typography>
                        <DatasheetView 
                            dataset={this.state.tm_array}
                            fieldspecs={this.datasheetFieldSpecs_tm}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.querying}
                            deleteHeaderName={''}
                            // pagesize={10}
                            // height={500}
                        />

                        {/* Interventions datagrid */}
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Learning Intervention History</Typography>
                        <DatasheetView 
                            dataset={this.state.interventions_array}
                            fieldspecs={this.datasheetFieldSpecs_interventions}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.querying}
                            deleteHeaderName={''}
                            // pagesize={10}
                            // height={500}
                        />

                        {/* Competencies datagrid */}
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Most Recent Competency Assessment</Typography>
                        <DatasheetView 
                            dataset={this.state.comps_array}
                            fieldspecs={this.datasheetFieldSpecs_competencies}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.querying}
                            deleteHeaderName={''}
                            // pagesize={10}
                            // height={500}
                        />

                        {/* Qualifications datagrid */}
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Qualifications</Typography>
                        <DatasheetView 
                            dataset={this.state.quals_array}
                            fieldspecs={this.datasheetFieldSpecs_qualifications}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.querying}
                            deleteHeaderName={''}
                            // pagesize={10}
                            // height={500}
                        />

                        {/* Qualifications datagrid */}
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>AutoExcel & SOP Certificates</Typography>
                        <DatasheetView 
                            dataset={this.state.lms_array}
                            fieldspecs={this.datasheetFieldSpecs_certificates}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.querying}
                            deleteHeaderName={''}
                            // pagesize={10}
                            // height={500}
                        />

                    </div>

                </Paper>}

                {this.state.show_view&&this.state.view_type==='assessment'&&
                <ViewAssessment 
                    assessment={this.state.current_record}
                    closeChild={() => {this.setState({current_record:{},show_view:false})}}
                    gwt={this.props.gwt}
                />}

                {this.state.show_view&&this.state.view_type==='360'&&
                <ViewThreeSixtyReport
                    current_record={this.state.current_record}
                    closeChild={() => {this.setState({current_record:{},show_view:false})}}
                    gwt={this.props.gwt}
                />}

                {this.state.show_view&&this.state.view_type==='TM'&&
                <ViewTMReport
                    current_record={this.state.current_record}
                    closeChild={() => {this.setState({current_record:{},show_view:false})}}
                    gwt={this.props.gwt}
                />}

            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1250,maxWidth:1250, textAlign:'center',marginBottom:'15px'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}